export const WorkflowElementIdConstants = {
  WorkflowDocumentViewerContainerId: 'workflowJobDocumentViewerContainer'
};